import { Component,  EventEmitter,  Input, Output, ViewChild } from '@angular/core';
import { DropdownOption } from '../../../../globals/store/programs.data';
import { jsonCopyObject } from '../../../../globals/helpers/helpers';
import { SearchBarComponent } from './../search-bar';
import { sleepForMS } from './../../helpers/helpers';
import {MatMenuModule} from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'dropdown',
    imports: [MatMenuModule, CommonModule, IconComponent, SearchBarComponent],
    template: `
<div [matMenuTriggerFor]="dropdown" class="dropdown-label" [ngClass]="{ disabled: disableDropdown }" (click)="$event.stopPropagation()">
    <div class="name" [style.font-family]="selected?.font || 'ubuntu, Helvetica, Arial'">{{ selected?.title || null_text }}</div>
    <div style="flex:1;" *ngIf="fullSpread"></div>
    <icon class="drop" *ngIf="!disableDropdown" matIcon="arrow_drop_down"></icon>
</div>
<mat-menu #dropdown="matMenu">
  <ng-content select=".header"></ng-content>
  <div class="search-holder" *ngIf="showSearch">
    <search-bar #searchBar [debounceTime]="10" [gray]="true" placeholder="Search" (keyword)="onSearchInput($event)" (click)="$event.stopPropagation()"></search-bar>
  </div>
  <div class="hint no-results" *ngIf="showSearch && !filteredSelections.length">No results</div>
  <button *ngFor="let option of (showSearch ? filteredSelections : selections)"
    mat-menu-item 
    [style.font-family]="option.font || 'ubuntu, Helvetica, Arial'"
    (click)="chooseSelection(option)"
  >{{ option.title ? option.title : emptyText }}</button>
</mat-menu>
  `,
    styles: [`
.dropdown-label { cursor: pointer; display: flex; align-items: center;  white-space: nowrap; width: fit-content; }
icon { display: block; margin-left: 5px; }
.disabled { pointer-events: none; }
.search-holder { padding: 10px; background: white; position: sticky; top: 0px; margin-top: -10px; z-index: 1000;
    border-bottom: 1px solid #f3f3f3; }
.no-results { margin-left: 20px; }
`],
    standalone: true
})
export class DropdownComponent<T, D extends DropdownOption<T>> {
  @Input() selections: D[]
  @Input() selected: D
  @Input() disableSelect = false
  @Input() disableDropdown = false
  @Input() showSearch = false
  filteredSelections: D[]
  search = ''

  @Input() fullSpread = true
  @Input() null_text = 'ok';
  @Input() emptyText: string = 'Untitled Option'
  @Output() select: EventEmitter<D> = new EventEmitter()
  @ViewChild(SearchBarComponent) searchBar: SearchBarComponent

  ngOnInit() {
    if (this.showSearch) this.filteredSelections = this.selections
  }

  async onSearchInput(term: string) {
    term = term.toLocaleLowerCase()
    this.filteredSelections = !term ? this.selections : this.selections.filter(s => s.title.toLocaleLowerCase().includes(term))
    await sleepForMS(10)
    this.searchBar.focus()
  }

  chooseSelection(selectedOption: D) {
    if (jsonCopyObject(selectedOption) === jsonCopyObject(this.selected)) return
    if (!this.disableSelect) this.selected = selectedOption
    this.select.emit(selectedOption)
    if (this.showSearch) this.searchBar.clear()
  }

}